import { render, staticRenderFns } from "./question-img.vue?vue&type=template&id=afef4520&scoped=true&"
import script from "./question-img.vue?vue&type=script&lang=ts&"
export * from "./question-img.vue?vue&type=script&lang=ts&"
import style0 from "./question-img.vue?vue&type=style&index=0&id=afef4520&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afef4520",
  null
  
)

export default component.exports